import React, {Component} from "react"

import {ReportType} from "@irati/types"
import {H2, H4, Label} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {FormattedMessage, FormattedCurrency, injectIntl, InjectIntl} from "@irati/utils/lang"
import {getWalletBalance} from "@irati/wallet/services/wallet"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import authentication from "@irati/auth"
import mainTheme from "@irati/ui/src/global/theme"
import {ActiveCard} from "@irati-web/wallet/src/components/WalletBalanceCard/styled"

import {ImageCard} from "./styled"

interface Props extends InjectIntl {
  id?: string
  title: string
  badge: any
  currencyColor?: string
  walletType: string
  reportType: ReportType
}

interface State {
  availableBalance: number | null
  currency: string
  csvLoad: Promise<any> | null
  uuid: string | null
}

class WalletCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    const variables = {
      tenantId: authentication.business().uuid,
      currency: authentication.defaultUserCurrency(),
      walletType: props.walletType
    }
    this.state = {
      availableBalance: null,
      currency: authentication.defaultUserCurrency(),
      csvLoad: null,
      uuid: null
    }
    getWalletBalance(variables).then((res: any) => this.setState({availableBalance: res.getWalletBalanceAtTime.value}))
  }

  handleCSVDownload = () => {
    const {reportType} = this.props

    const csvLoad = adminReportingService.getRewardsReportUrl(authentication.business().uuid, reportType).then(({reportFileUrl}) => {
      const fileName = `${reportType.replace("_", "-").toLocaleLowerCase()}-log.csv`
      const link = document.createElement("a")
      link.setAttribute("href", reportFileUrl)
      link.setAttribute("download", fileName)
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    this.setState({csvLoad})
  }

  render() {
    const {title, badge, currencyColor, id} = this.props
    const {availableBalance, currency, csvLoad} = this.state

    return (
      <ActiveCard marginTop={3}>
        <ImageCard src={badge} alt="" />
        <H4 marginTop={1} marginBottom={2}>
          {title}
        </H4>
        <Flex justifyContent="space-between">
          <Flex direction="column">
            <Label marginBottom={0.5} color={mainTheme.colors.utility.contrast}>
              <FormattedMessage id="admin.analytics.people.walletCard.availableBalanceText" />
            </Label>
            <H2 color={currencyColor || mainTheme.colors.tertiary.g_400}>
              {currency && <FormattedCurrency isCents value={availableBalance} currency={currency} />}
            </H2>
          </Flex>
        </Flex>
        <Button id={`${id}_button`} marginTop={2} full primary onClick={this.handleCSVDownload} load={csvLoad}>
          <FormattedMessage id="admin.reporting.wallet.downloadReport" />
          <Icon icon={IconTypes.downloadReport} marginLeft />
        </Button>
      </ActiveCard>
    )
  }
}

export default injectIntl(WalletCard)
